export default __webpack_public_path__ + "static/media/aurora.ab34da6b.svg";